import * as React from 'react';

// eslint-disable-next-line
type ComponentConstructor = React.JSXElementConstructor<React.PropsWithChildren<any>>;

interface IProps {
  components: Array<ComponentConstructor>
  children: React.ReactNode
}

export function Compose(props: IProps) {
  const { components = [], children } = props;
  return (
    <>
      {components.reduceRight((acc, Comp) => {
        return <Comp>{acc}</Comp>;
      }, children)}
    </>
  );
}

type PropsOf<T extends ComponentConstructor> = React.ComponentProps<T>;

export function withProps<T extends ComponentConstructor>(injectedProps: Omit<PropsOf<T>, 'children'>) {
  return (WrappedComponent: ComponentConstructor) => {
    const WithProps = (props: PropsOf<T>) => <WrappedComponent {...injectedProps} {...props} />;
    return WithProps;
  };
}

